// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/faculty_card_background.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faculty-card-profile {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.faculty-card-profile .word-map {
  margin-top: 20px;
  margin-bottom: 30px;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  position: relative;
}
.faculty-card-profile .base-stat .base {
  display: flex;
  width: 100%;
}
.faculty-card-profile .base-stat .base .stat-card {
  padding: 5px 15px;
  border-radius: 10px;
  border: 1px solid var(--light-grey);
  margin-right: 10px;
  width: 190px;
}
.faculty-card-profile .base-stat .base .stat-card:hover {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  border: 1px solid white;
}
.faculty-card-profile .bio {
  margin-bottom: 10px;
}
.faculty-card-profile .bio p {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.faculty-card-profile .title-part {
  font-size: 25px;
  margin-bottom: 20px !important;
  font-weight: bold;
}
.faculty-card-profile .advance-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.faculty-card-profile .advance-info .advance-stat {
  width: 100% !important;
}
.faculty-card-profile .position p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/FacultyCard.scss"],"names":[],"mappings":"AAAA;EACE,yDAAA;AACF;AAAE;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;AAEJ;AACI;EACE,aAAA;EACA,WAAA;AACN;AAAM;EACE,iBAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,YAAA;AAER;AAAM;EACE,0CAAA;EACA,uBAAA;AAER;AAGE;EACE,mBAAA;AADJ;AAEI;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAAN;AAGE;EACE,eAAA;EACA,8BAAA;EACA,iBAAA;AADJ;AAGE;EACE,WAAA;EACA,aAAA;EACA,8BAAA;AADJ;AAEI;EACE,sBAAA;AAAN;AAQI;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AANN","sourcesContent":[".faculty-card-profile {\n  background-image: url(\"../Assets/faculty_card_background.jpeg\");\n  .word-map {\n    margin-top: 20px;\n    margin-bottom: 30px;\n    padding: 25px;\n    border-radius: 10px;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n    position: relative;\n  }\n  .base-stat {\n    .base {\n      display: flex;\n      width: 100%;\n      .stat-card {\n        padding: 5px 15px;\n        border-radius: 10px;\n        border: 1px solid var(--light-grey);\n        margin-right: 10px;\n        width: 190px;\n      }\n      .stat-card:hover {\n        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n        border: 1px solid white;\n      }\n    }\n  }\n\n  .bio {\n    margin-bottom: 10px;\n    p {\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    }\n  }\n  .title-part {\n    font-size: 25px;\n    margin-bottom: 20px !important;\n    font-weight: bold;\n  }\n  .advance-info {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    .advance-stat {\n      width: 100% !important;\n    }\n    // .academic-experiences {\n    //   width: 58%;\n    // }\n  }\n\n  .position {\n    p {\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
